import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pipeStatusMqtt'
})
export class PipeStatusMqtt implements PipeTransform {
    constructor() { }
    transform(status) {
        if (status == '000') {
            return 'Disponível';
        } else if (status == '001') {
            return 'Ocupado';
        } else if (status == '5') {
            return 'Rede Resetada';
        } else if (status == '7') {
            return 'Device Resetado';
        } else {
            return
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeStatusMqtt.ts